import React, { useState, useEffect } from "react";
// Removed: import "bootstrap/dist/css/bootstrap.min.css"; 

const Services = () => {
  // --- STATE AND RESPONSIVENESS LOGIC ---
  const primaryHeaders = [
    "White Label",
    "Custom Development",
    "Clinical Studies",
  ];

  const [currentHeaderIndex, setCurrentHeaderIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // 1. Hook to handle window resize for responsiveness
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 2. Hook to handle the header cycling animation
  useEffect(() => {
    const interval = setInterval(() => {
      // Cycles to the next header, looping back to 0
      setCurrentHeaderIndex(
        (prevIndex) => (prevIndex + 1) % primaryHeaders.length
      );
    }, 3000); // Cycles every 3 seconds

    return () => clearInterval(interval);
  }, [primaryHeaders.length]);
  // --- END STATE AND RESPONSIVENESS LOGIC ---

  const responsiveMinHeight = windowWidth <= 1600 ? '600px' : '100vh';

  // Dummy content for the long-form section to mimic a book page
  const serviceParagraphs = [
    {
      id: 1,
      title: "White label",
      content:
      "We cater to the growing demands of vitamin supplements and plant-based nutrition industry as a white-label partner. We offer end-to-end solution to your development problem. Our white label solution brings together an integrated program and a turn key management of your brand with the spectrum of our vitamers and other related ingredients. Our white label scope is limited to our Orgavitaz range only. We are not just a manufacturer, our supply chain strength integrates R&D, agriculture, formulations, manufacturing and clinical studies."
    },
    {
      id: 2,
      title: "Custom Development",
      content:
      "Orgavitaz goes beyond just offering a spectrum of bio-vitamers forcing our standardized range. Orgavitaz is also a platform for building custom formulations. We recognize the need for customizing the requirements fitting the trend, conditions and other development scope. We standardize the formulation and test the stability of the product, dosage and even the in vitro efficacy studies shall be conducted to establish a full fledged paper work for regulatory needs. We facilitate the development process through a structured requirements elicitation process and validate the formulation for the novelty and RDA claims."
    },
    {
      id: 3,
      title: "Clinical Studies",
      content:
      "If you are looking to position your branded ingredient as a clinical ingredient, we bring the in-house clinical studies infrastructure with more than a decade of experience in clinical studies. Our experienced and approved institutional ethics committee ensure that your trial is coordinated with highest integrity. Our integrated clinicals studies services include protocol development, approval, registration, investigators and clinical coordinators appointment, subject recruitments, trial conduct, data analysis and reporting for submissions. We assure a a high quality trials at an affordable cost and ensure a comprehensive study scope for wider market claims."
    },
  ];

  const handleScroll = () => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    // FIX: Added overflowX: "hidden" to prevent banner overflow causing horizontal scrollbar
    <div className="bg-light" style={{ overflowX: "hidden" }}> 
      {/* --------------------- 1. FULL-HEIGHT DYNAMIC BANNER SECTION --------------------- */}
      <header
        className="d-flex flex-column justify-content-center align-items-center text-center text-white shadow-lg"
        style={{
          // FIX: Use responsive minHeight
          minHeight: responsiveMinHeight, 
          // FIX: Use 100% width to prevent overflow
          width: "100%", 
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.7)), url('/images/Services/Services.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative", // Ensure button position works
        }}
      >
        <div className="container p-4">
          {/* Header 2 (Dynamic/Scrolling Main Header) */}
          <h1
            className="display-4 mb-4"
            style={{
              textShadow: "0 4px 6px rgba(0, 0, 0, 0.5)",
              // Use fixed 3s animation duration to match the JavaScript interval
              animation: 'fadeInOut 3s ease-in-out', 
            }}
            // Changing the key forces the h1 to re-render, restarting the animation
            key={currentHeaderIndex}
          >
            {primaryHeaders[currentHeaderIndex]}
          </h1>

          {/* Scroll Down Button */}
          <button
            onClick={handleScroll}
            className="btn btn-outline-light btn-lg mt-5"
            aria-label="Scroll down to content"
            style={{ 
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              padding: 0,
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
            }}
          >
            <i className="bi bi-arrow-down-short display-6"></i>
          </button>
        </div>
      </header>

      {/* --------------------- 2. CONTENT SECTION (BOOK PAGE STYLE) --------------------- */}
      <main id="main-content" className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            {/* Limiting width for optimal reading experience */}
            <div className="col-lg-8">
              <h3 className="text-center mb-5 pb-2 border-bottom border-primary">
                Our Core Services
              </h3>

              {serviceParagraphs.map((service, index) => (
                <div key={service.id} className="mb-5">
                  <h4 className="fw-bold text-dark mb-3">
                    <span className="me-2">{index + 1}.</span>
                    {service.title}
                  </h4>
                  <p className="lead text-secondary" style={{ lineHeight: "1.8", textAlign: "justify",fontSize: "1rem" }}>
                    {service.content}
                  </p>
                  {index < serviceParagraphs.length - 1 && (
                    <hr className="my-4 w-25 mx-auto border-info" />
                  )}
                </div>
              ))}

              <p className="text-center fst-italic text-muted mt-5">
                Enquire for Clinical study support.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* --------------------- CSS for Animation --------------------- */}
      <style>
        {`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateY(20px); }
            5% { opacity: 1; transform: translateY(0); } /* Start fading in immediately */
            95% { opacity: 1; transform: translateY(0); } /* Hold visibility almost until the end */
            100% { opacity: 0; transform: translateY(-20px); } /* Fade out quickly at the end */
          }
        `}
      </style>
    </div>
  );
};

export default Services;